
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const CourierActions = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        props.onShowCourierTrack(props);
    };

    return (
        <div>
			<button onClick={handleClick} className="custom-btn label label-success" title="Track Courier"><i style={{fontSize:"20px"}} className="icofont icofont-fast-delivery"></i> </button>
       
        </div>
    );
};

export default CourierActions;
